import { BelongsToReferenceField, pageCollectionFields } from 'drapcode-constant';
import { getAllTypesenseSearchTemplates } from '../../apiUtils';
import { loadPageTraitOptions } from '../commonTraitsMethod/pageTraits';
import { componentRef } from './consts';

export default function (editor, opts = {}) {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  const { collections, projectId, version, pageCollection } = opts;

  domc.addType(componentRef, {
    model: defaultModel.extend(
      {
        defaults: {
          ...defaultModel.prototype.defaults,
          droppable: false,
          draggable: ':not(form)',
          icon: '<i class="wb webconnect-search"></i>',
          name: 'Typesense Search',
          resizable: true,
          traits: [...domc.getType('default').model.prototype.defaults.traits],
          script: function () {
            if (typeof renderTypesenseSearch !== 'undefined') {
              renderTypesenseSearch(this);
            }
          },
        },

        async updateTraits() {
          try {
            const pages = await loadPageTraitOptions(projectId, version);
            const typesenseSearchTemplates = await getAllTypesenseSearchTemplates(
              projectId,
              version,
            );
            const filteredCollections = collections
              .filter((col) => col.typesenseMapping.length)
              .map((col) => ({
                value: col.collectionName,
                label: col.collectionTitle,
                filters: col.finders,
                typesenseMapping: col.typesenseMapping,
              }));

            const collectionOptions = [
              { value: '', label: '- Select One -' },
              ...filteredCollections,
            ];

            const allCollectionOptions = [
              { value: '', label: '- Select One -' },
              ...collections.map((col) => ({
                value: col.collectionName,
                label: col.collectionTitle,
              })),
            ];

            const selectedCollectionValue = this.get('data-typesense-collection') || '';
            const selectedCollection = filteredCollections.find(
              (col) => col.value === selectedCollectionValue,
            );
            let typesenseMappingFieldOptions = [{ value: '', label: '- Select One -' }];
            let sortByFieldOptions = [{ value: '', label: '- Select One -' }];
            let searchByFieldOptions = [{ value: '', label: 'Default' }];
            if (selectedCollection && selectedCollection.typesenseMapping.length) {
              typesenseMappingFieldOptions = [
                { value: '', label: '- Select One -' },
                ...selectedCollection.typesenseMapping.map(({ fieldName, fieldTitle }) => ({
                  value: fieldName,
                  label: fieldTitle,
                })),
              ];
              sortByFieldOptions = [
                { value: '', label: '- Select One -' },
                ...selectedCollection.typesenseMapping
                  .filter((mapping) =>
                    ['number', 'createdAt', 'updatedAt'].includes(mapping.fieldType),
                  )
                  .map(({ fieldName, fieldTitle }) => ({
                    value: fieldName,
                    label: fieldTitle,
                  })),
              ];
              searchByFieldOptions = [
                { value: '', label: 'Default' },
                ...selectedCollection.typesenseMapping.map(({ fieldName, fieldTitle }) => ({
                  value: fieldName,
                  label: fieldTitle,
                })),
              ];
            }

            const filteredTemplates = selectedCollection
              ? typesenseSearchTemplates.filter(
                  (template) => template.collectionId === selectedCollectionValue,
                )
              : [];

            const typesenseSearchTemplatesOptions = [
              { value: '', label: '- Select One -' },
              ...filteredTemplates.map((template) => ({
                value: template.uuid,
                label: template.name,
              })),
            ];

            const pageOptions = [
              { value: '', label: '- Select One -' },
              ...pages.map((page) => ({ value: page.id, label: page.name })),
            ];

            const filterOptions = selectedCollection
              ? [
                  { value: '', label: '- Select One -' },
                  ...selectedCollection.filters.map((filter) => ({
                    value: filter.uuid,
                    label: filter.name,
                  })),
                ]
              : [{ value: '', label: '- Select One -' }];

            this.set('traits', [
              {
                type: 'select',
                label: 'Collection',
                name: 'data-typesense-collection',
                options: collectionOptions,
                changeProp: 1,
              },
              {
                type: 'select',
                label: 'Typesense Search Template',
                name: 'data-typesense-template',
                options: typesenseSearchTemplatesOptions,
                changeProp: 1,
              },
              {
                type: 'select',
                label: 'Filter',
                name: 'data-typesense-filter',
                options: filterOptions,
                changeProp: 1,
              },
              {
                type: 'select',
                label: 'Redirect Page',
                name: 'data-typesense-redirect-page',
                options: pageOptions,
                changeProp: 1,
              },
              {
                type: 'select',
                label: 'Redirect Collection (Optional)',
                name: 'data-typesense-redirect-collection',
                options: allCollectionOptions,
                changeProp: 1,
              },
              {
                type: 'select',
                label: 'Path Link ID (Optional)',
                name: 'data-typesense-redirect-item-id',
                options: typesenseMappingFieldOptions,
                changeProp: 1,
              },
              {
                type: 'checkbox',
                label: 'Open in new tab',
                name: 'data-newtab',
              },
              {
                type: 'select',
                label: 'Search By (Optional)',
                name: 'data-typesense-search-by',
                options: searchByFieldOptions,
                changeProp: 1,
              },
              {
                type: 'select',
                label: 'Sort By',
                name: 'data-typesense-sort-by',
                options: sortByFieldOptions,
                changeProp: 1,
              },
              {
                type: 'select',
                label: 'Sort Order',
                name: 'data-typesense-sort-order',
                value: '',
                changeProp: 1,
                options: [
                  { id: '', name: '- Select One -' },
                  { id: 'asc', name: 'Ascending' },
                  { id: 'desc', name: 'Descending' },
                ],
              },
              {
                type: 'number',
                label: 'Results Limit',
                name: 'data-typesense-results-limit',
                min: 1,
                step: 10,
                max: 250,
                value: 20,
                placeholder: 'Default: 20',
              },
              {
                type: 'select',
                label: 'View Type',
                name: 'data-typesense-view-type',
                value: '',
                changeProp: 1,
                options: [
                  { id: '', name: '- Select One -' },
                  { id: 'list', name: 'List' },
                  { id: 'card', name: 'Card' },
                ],
              },
              ...domc.getType('default').model.prototype.defaults.traits,
            ]);
            if (this.get('data-typesense-view-type') === 'card') {
              this.addTrait(
                {
                  type: 'number',
                  label: 'Records per Row',
                  name: 'data-typesense-recordsPerRow',
                  min: 1,
                  step: 1,
                  max: 3,
                  value: 3,
                  placeholder: 'Default: 3',
                },
                { at: 12 },
              );
            } else {
              this.removeTrait('data-typesense-recordsPerRow');
            }
          } catch (error) {
            console.error('Error updating traits:', error);
          }
        },

        syncTraitToAttribute(traitName) {
          const value = this.get(traitName);
          const currentAttributes = this.get('attributes') || {};
          this.set('attributes', {
            ...currentAttributes,
            [traitName]: value,
          });
        },

        async init() {
          this.updateTraits = this.updateTraits.bind(this);
          await this.updateTraits();
          await this.updateFilter();
          this.listenTo(this, 'change:data-typesense-collection', () => {
            this.updateTraits();
            this.syncTraitToAttribute('data-typesense-collection');
          });
          this.listenTo(this, 'change:data-typesense-view-type', () => {
            this.updateViewTypeField();
            this.syncTraitToAttribute('data-typesense-view-type');
          });
          this.listenTo(this, 'change:data-typesense-filter', async () => {
            await this.updateFilter();
            this.syncTraitToAttribute('data-typesense-filter');
          });

          const traitNamesToTrack = [
            'data-typesense-template',
            'data-typesense-redirect-page',
            'data-typesense-redirect-collection',
            'data-typesense-redirect-item-id',
            'data-typesense-sort-by',
            'data-typesense-sort-order',
            'data-typesense-results-limit',
            'data-newtab',
            'data-typesense-records-per-row',
            'data-typesense-search-by',
          ];

          traitNamesToTrack.forEach((trait) => {
            this.listenTo(this, `change:${trait}`, () => this.syncTraitToAttribute(trait));
          });
        },

        updateViewTypeField() {
          const viewType = this.get('data-typesense-view-type');
          const component = editor.getSelected();
          const typesenseParentDiv = component.find('[typesense-results-container]')[0];
          if (viewType === 'card') {
            this.addTrait(
              {
                type: 'number',
                label: 'Records per Row',
                name: 'data-typesense-recordsPerRow',
                min: 1,
                step: 1,
                max: 3,
                value: 3,
              },
              { at: 12 },
            );
          } else {
            this.removeTrait('data-typesense-recordsPerRow');
          }
          if (!typesenseParentDiv) {
            console.error('Typesense Parent Div not found.');
            return;
          }
          let typesenseParentDivHTML = '';
          if (viewType === 'list') {
            typesenseParentDivHTML = `<ul id="typesense-results" class="typesense-dropdown">
              <li id="typesense-list" class="list-group-item bg-light border rounded shadow-sm p-2">
                <a id="typesense-anchor" class="text-decoration-none text-dark d-block w-100 p-2 rounded" href="#">
                  Result 1
                </a>
              </li>
            </ul>`;
          } else if (viewType === 'card') {
            typesenseParentDivHTML = `<div id="typesense-results">
              <div class ="card shadow-sm overflow-auto" id="typesense-results-card">
                <div class="card-body" id="typesense-results-card-body">
                  <a id="typesense-anchor" class="text-decoration-none text-dark d-block w-100 p-2 rounded" href="#">
                     Result 1
                  </a>
                </div>
              </div>
            </div>`;
          }
          typesenseParentDiv.components(typesenseParentDivHTML);
        },
        async updateFilter() {
          try {
            const currentAttributes = this.get('attributes') || {};
            if (currentAttributes.externalQueryParamKeys) {
              currentAttributes.externalQueryParamKeys.forEach((param) => this.removeTrait(param));
              const updatedAttributes = { ...currentAttributes };
              delete updatedAttributes.externalQueryParamKeys;
              this.set({ attributes: updatedAttributes });
            }
            const selectedCollectionValue = this.get('data-typesense-collection') || '';
            const selectedCollection = collections.find(
              (col) => col.collectionName === selectedCollectionValue,
            );
            const finder = this.get('data-typesense-filter');
            const finders = selectedCollection ? selectedCollection.finders : [];
            const selectedFinder = finders.find((f) => f.uuid === finder);
            let externalQueryParamKeys = [];
            if (selectedFinder && selectedFinder.noOfExternalParams > 0) {
              let pageCollectionOptions = pageCollection.options || [];
              pageCollectionOptions = pageCollectionOptions.filter((opt) =>
                [...pageCollectionFields, ...BelongsToReferenceField].includes(opt.type),
              );
              if (selectedFinder.conditions) {
                selectedFinder.conditions.forEach((condition) => {
                  if (condition.requiredExternal) {
                    const val = condition.query.value;
                    if (val.includes('---')) {
                      const [a, b] = val.split('---');
                      externalQueryParamKeys.push(a, b);
                    } else {
                      externalQueryParamKeys.push(val);
                    }
                  }
                });
              }

              externalQueryParamKeys.forEach((extParam) => {
                this.addTrait({
                  name: extParam,
                  label: extParam,
                  options: pageCollectionOptions,
                  title: extParam,
                  type: 'select',
                  value: this.get(extParam) || '',
                });
              });
              this.set({
                attributes: {
                  ...this.getAttributes(),
                  externalQueryParamKeys,
                },
              });
            }
          } catch (error) {
            console.error('Error updating filter:', error);
          }
        },
      },
      {
        isComponent(el) {
          if (el.getAttribute && el.getAttribute('data-gjs-type') === 'typesense-search') {
            return { type: componentRef };
          }
        },
      },
    ),

    view: defaultView.extend({
      events: {
        submit(e) {
          e.preventDefault();
        },
      },
      init({ model }) {
        this.listenTo(model, 'change:data-typesense-collection', model.updateTraits);
        this.listenTo(model, 'change:data-typesense-template', this.updateScript);
        this.listenTo(model, 'change:data-typesense-filter', this.updateScript);
        this.listenTo(model, 'change:data-typesense-redirect-page', this.updateScript);
        this.listenTo(model, 'change:data-typesense-view-type', this.updateScript);
        this.listenTo(model, 'change:data-typesense-redirect-collection', this.updateScript);
        this.listenTo(model, 'change:data-typesense-redirect-item-id', this.updateScript);
        this.listenTo(model, 'change:data-typesense-sort-by', this.updateScript);
        this.listenTo(model, 'change:data-typesense-sort-order', this.updateScript);
        this.listenTo(model, 'change:data-typesense-search-by', this.updateScript);
      },
    }),
  });
}
